// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"324":"284f62e8","895":"3dfe1b96"}[chunkId] + ".chunk.css");